import type { BulkAddPersonSyncItem } from "@/pages/Private/pages/List/schema/list";
import type { MyConnections } from "@/pages/Public/pages/Login/schema/login";

/**
 * The bulk-add item for one LinkedIn connection (PREC-4946). An enriched connection is added by
 * its prospectId and also carries its LinkedIn URL: a connection linked before the per-company
 * split can point at another company's prospect, which the API refuses to link and then adds
 * from this URL instead. A connection that is not enriched is added by its URL alone.
 */
export const connectionBulkAddItem = (
	connection: Pick<MyConnections, "isEnriched" | "prospectId" | "linkedinUrl">
): BulkAddPersonSyncItem => {
	const { isEnriched, prospectId, linkedinUrl } = connection;

	if (!isEnriched || !prospectId) {
		return { linkedinUrl };
	}

	return linkedinUrl ? { prospectId, linkedinUrl } : { prospectId };
};
